import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import { Apitoken, Authtoken } from "../Global";
import { loader_image } from "../_components/Imagepath";
import $ from "jquery";
import { createRoot } from 'react-dom/client';
import PropTypes from 'prop-types';

var Barcode = require('react-barcode');
const ViewRawMaterial = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [value, setValue] = useState({});
  const [barcodeSuppliers, setBarcodeSuppliers] = useState([]);
  const [barcodeProducts, setBarcodeProducts] = useState([]);
  const [permission, setPermission] = useState({});

  let season_id = localStorage.getItem("season_id");

  useEffect(() => {
    setPermission(FindModuleById(42));
    console.log(permission);


    axios
      .get(`/raw-materials/details-raw-material/${season_id + '-' + id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          setValue(response.data.data.raw);
          console.log(response.data.data.raw);
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .post(
        "/products/listing-category-type",
        {},
        {
          headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let products = response.data.data.products;
          setBarcodeProducts(products);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });

    axios
      .post(
        "/suppliers-trader/listing",
        {},
        {
          headers: {
            Authorization: `Bearer ${Authtoken}`,
            Apitoken: Apitoken,
          },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          let suppliers = response.data.data.suppliers;
          setBarcodeSuppliers(suppliers);
        } else {
          console.log("API response is not an array");
        }
      })
      .catch((error) => {
        console.log(error);
      });



  }, [id]);



  const toggleMobileMenu = () => {
    setMenu(!menu);
  };



  const handleDownloadRawMaterial = async () => {
    if (!value.lot_number) {
      console.error('Lot number is not available yet');
      return;
    }
    let season_id = localStorage.getItem("season_id");

    $("#loader-image2").removeClass('loader-hide');
    $("#loader-image2").addClass('loader-show');

    axios.get(`/raw-materials/pdf-raw-material/${season_id + '-' + id}`, {
      responseType: 'blob',
      headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken }
    })
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        let file_name = value.lot_number + '.pdf';
        link.download = file_name;
        link.click();

        $("#loader-image2").addClass('loader-hide');
        $("#loader-image2").removeClass('loader-show');
      })
      .catch(error => {
        console.error('Error downloading PDF:', error);
        $("#loader-image2").addClass('loader-hide');
        $("#loader-image2").removeClass('loader-show');
      });
  };

  const handleDownload = (barcode_data) => {
    const supplierId = value.supplier;
    const product_details = barcodeProducts.find(user => user.id === barcode_data.product);
    const supplier_details = barcodeSuppliers.find(user => user.id === supplierId);
    const supplier_name = (supplier_details && supplier_details.name) ? supplier_details.name : "";

    let get_contents = '';
    get_contents += '<div id="div-print">';

    get_contents += '<table class="table" style="width:100%">';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Lot Number#</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + value.lot_number + '</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Date And Time#</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + value.date_time + '</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Service.P</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + supplier_name + '</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Product</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + product_details.productname + '</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Gross Weight:</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + barcode_data.gross_weight + 'KG</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Net Weight:</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + barcode_data.net_weight + 'KG</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Boxes#</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + barcode_data.number_of_boxes + '</td></tr>';
    get_contents += '<tr><td style="font-size: 40px; font-family: monospace;">Barcode#</td><td style="font-size: 40px; font-family: monospace; font-weight: 600;">' + barcode_data.barcode + '</td></tr>';
    get_contents += '</table><br/>';

    // Dynamically create temporary div to render BarcodeComponent
    const tempDiv = document.createElement('div');
    document.body.appendChild(tempDiv);

    const root = createRoot(tempDiv);
    root.render(<BarcodeComponent barcodeData={barcode_data.barcode} />);

    // Delay to allow React to render before reading innerHTML
    setTimeout(() => {
      const barcodeHtml = tempDiv.innerHTML;
      get_contents += barcodeHtml;
      get_contents += '</div>';

      const width = 300;
      const height = 300;
      const widthInPixels = width * 3.779527559;
      const heightInPixels = height * 3.779527559;
      const left = (window.screen.width - widthInPixels) / 2;
      const top = (window.screen.height - heightInPixels) / 2;
      const windowFeatures = `width=${widthInPixels},height=${heightInPixels},left=${left},top=${top}`;

      const printWindow = window.open('', '', windowFeatures);
      printWindow.document.open();
      printWindow.document.write('<html><head><title>Print</title></head><body style="font-size:25px;">');
      printWindow.document.write(get_contents);
      printWindow.document.write('</body></html>');
      printWindow.document.close();

      // Delay print slightly to ensure DOM is ready
      setTimeout(() => {
        printWindow.print();
        printWindow.close();
      }, 500);

      // Clean up temp div
      document.body.removeChild(tempDiv);
    }, 500);
  };

  const BarcodeComponent = ({ barcodeData }) => {
    return (
      <div>
        <Barcode value={barcodeData} width={7} height={120} displayValue={false} />
      </div>
    );
  };
  BarcodeComponent.propTypes = {
    barcodeData: PropTypes.string.isRequired, // Assuming barcodeData is a string
  };
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Raw Material</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/raw-materials">Raw Materials</Link>
                    </li>
                    <li className="breadcrumb-item active">
                      View Raw Material
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {permission && permission.list == 1 && (
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <h4 className="card-title">View Raw Material Info</h4>
                      <div style={{ float: "right" }}>
                        <button onClick={() => handleDownloadRawMaterial()} className="btn btn-primary me-1"  > Download Raw Material <i className="fa fa-download" /> <img id="loader-image2" className="loader-image loader-hide" src={loader_image} />  </button>
                      </div>
                      <table className="table table-bordered">
                        <tr>
                          <th className="p-3">Lot Number</th>
                          <td className="p-3">
                            {value.lot_number}
                            {/* <Barcode value={value.lot_number} />, */}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Date & Time</th>
                          <td className="p-3">{value.date_time}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Shift Date</th>
                          <td className="p-3">{value.shift_date}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Supplier Name</th>
                          <td className="p-3">
                            {value.supplier ? value.supplier_name.name : ""}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">Plate Number</th>
                          <td className="p-3">{value.plate_number}</td>
                        </tr>
                        <tr>
                          <th className="p-3">Total Net Weight</th>
                          <td className="p-3">{typeof value.net_weight_total === 'number' ? value.net_weight_total.toFixed(2) : '0'} (KG)


                          </td>
                        </tr>
                        <tr>
                          <th className="p-3">BL Net Weight</th>
                          <td className="p-3">{value.net_weight} (KG)</td>
                        </tr>
                        <tr>
                          <th className="p-3">Farm Name</th>
                          <td className="p-3">
                            {value.farmer_detail ? value.farmer_detail.name : ""}
                          </td>
                        </tr>


                        <tr>
                          <th className="p-3">Driver Name</th>
                          <td className="p-3">{value.driver_name}</td>
                        </tr>


                        <tr>
                          <th className="p-3">Location</th>
                          <td className="p-3">
                            {value.location ? value.location_name.title : ""}
                          </td>
                        </tr>



                        <tr>
                          <th className="p-3">BL Gross Weight</th>
                          <td className="p-3">{value.gross_weight} (KG)</td>
                        </tr>

                        <tr>
                          <th className="p-3">Date Time</th>
                          <td className="p-3">{value.date_time}</td>
                        </tr>

                        <tr>
                          <th className="p-3">Product</th>
                          <td className="p-3">
                            {value.product_name
                              ? value.product_name.name
                              : ""}
                          </td>
                        </tr>



                        <tr>
                          <th className="p-3" colSpan={2}><h3>Quality Check </h3></th>
                        </tr>
                        <tr>
                          <th className="p-3">Calibre Dominant</th>
                          <td className="p-3">{value.quality_check_calibre_dominant}</td>
                        </tr>
                        <tr>
                          <th className="p-3 ">Petit Calibre</th>
                          <td className="p-3">{value.quality_check_petit_calibre}</td>
                        </tr>
                        <tr>
                          <th className="p-3 ">Dechet</th>
                          <td className="p-3">{value.quality_check_dechet}</td>
                        </tr>

                        <tr>
                          <th className="p-3 ">Status</th>
                          <td className="p-3">
                            {value.check_status
                              ? value.check_status.title
                              : ""}
                          </td>
                        </tr>
                        <tr>
                          <th className="p-3 ">Remarks</th>
                          <td className="p-3">{value.quality_check_remarks}</td>
                        </tr>

                        <tr>
                          <th className="p-3" colSpan={2}><h3>Crates follow Up </h3></th>
                        </tr>
                        <tr>
                          <th className="p-3">Boxes IN</th>
                          <td className="p-3">{value.boxes_in}</td>
                        </tr>

                      </table>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {permission && permission.list == 1 && (
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title"> </h5>

                      <table className="table table-bordered  text-center">
                        <thead>
                          <tr>
                       <th className='text-center' colSpan="7">
                    <h3>
                      <u>
                        Dechet de Ferme {value.palletesations_type1 && value.palletesations_type1.length > 0 
                          ? value.palletesations_type1.reduce((sum, item) => sum + parseFloat(item.net_weight || 0), 0).toFixed(2) 
                          : '0.00'} KG
                      </u>
                    </h3>
                  </th>
                    </tr>
                          <tr>
                            <th className="p-3">Barcode</th>
                            <th className="p-3 text-center">Product</th>
                            <th className="p-3 text-center">Type</th>
                            <th className="p-3 text-center">Gross Weight</th>
                            <th className="p-3 text-center">Net Weight</th>
                            <th className="p-3 text-center">Number oF Boxes</th>
                            <th className="p-3 pull-right">Download</th>
                          </tr>
                        </thead>
                        <tbody>
                          {value.palletesations_type1 &&
                            value.palletesations_type1.map((item, indx) => (
                              <tr key={item.barcode || indx}>
                                <td className="p-3">{item.barcode}</td>
                                <td className="p-3">{item.product_name}</td>
                                <td className="p-3">{item.type_name}</td>
                                <td className="p-3 text-center">{item.gross_weight} (KG)</td>
                                <td className="p-3 text-center">{item.net_weight} (KG)</td>
                                <td className="p-3 text-center">{item.number_of_boxes}</td>

                                <td>
                                  <div style={{ float: "right" }}>
                                    <button onClick={() => handleDownload(item)} className="btn btn-primary me-1"  > Print Label <i className="fa fa-print" /> <img id={`item-${item.barcode}`} className="loader-image loader-hide" src={loader_image} />  </button>
                                  </div>
                                </td>
                              </tr>
                            ))}

                        </tbody>

                      </table>
                    </div>
                  </div>


                </div>
              </div>
            )}

            {permission && permission.list == 1 && (
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body">
                      <h5 className="card-title"> </h5>
                     {value.raw_groupby &&
                        Object.entries(value.raw_groupby).map(([productName, items], indx) => {
                          const totalNetWeight = items.reduce((sum, item) => sum + parseFloat(item.net_weight || 0), 0);
                          
                          return (
                            <table key={indx} className="table table-bordered text-center">
                              <thead>
                              <th className='text-center' colSpan="7" ><h3><u>{productName} - Total Net Weight: {totalNetWeight.toFixed(2)} KG</u></h3></th>
                        
                                <tr>
                                  <th className="p-3">Barcode</th>
                                  <th className="p-3 text-center">Product</th>
                                  <th className="p-3 text-center">Type</th>
                                  <th className="p-3 text-center">Gross Weight</th>
                                  <th className="p-3 text-center">Net Weight</th>
                                  <th className="p-3 text-center">Number of Boxes</th>
                                  <th className="p-3 pull-right">Download</th>
                                </tr>
                              </thead>
                              <tbody>
                                {items.map((item, itemIndx) => (
                                  <tr key={item.barcode || itemIndx}>
                                    <td className="p-3">{item.barcode}</td>
                                    <td className="p-3">{item.product_name}</td>
                                    <td className="p-3">{item.type_name}</td>
                                    <td className="p-3 text-center">{item.gross_weight} (KG)</td>
                                    <td className="p-3 text-center">{item.net_weight} (KG)</td>
                                    <td className="p-3 text-center">{item.number_of_boxes}</td>
                                    <td>
                                      <div style={{ float: "right" }}>
                                        <button 
                                          onClick={() => handleDownload(item)} 
                                          className="btn btn-primary me-1"
                                        >
                                          Print Label <i className="fa fa-print" /> 
                                          <img 
                                            id={`item-${item.barcode}`} 
                                            className="loader-image loader-hide" 
                                            src={loader_image} 
                                          />
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          );
                        })
                      }
                    </div>
                  </div>


                </div>
              </div>
            )}

           
          </div>
        </div>
      </div>
    </>
  );
};
export default ViewRawMaterial;
